import { render } from "./MainHeader.vue?vue&type=template&id=2adb5184&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=2adb5184&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adb5184"]])

export default __exports__